import createReducer from '../../../../helpers/createReducer';
import { fetchAssociationLinkOptions } from '../../../sagas/routines';

const initialState = {
  all: [],
  meta: {},
  fetching: false,
  fetched: false
};

const fetchHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    all: response.items,
    meta: response.meta
  }),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchHandler(fetchAssociationLinkOptions)
});
